<p-tabView *ngIf="!campaignId || campaign">
  <p-tabPanel header="Informações">
    <form class="form-b4a" [formGroup]="form" (ngSubmit)="save()">
      <div class="form-row form-row--header">
        <span class="p-float-label">
          <input
            type="text"
            pInputText
            formControlName="title"
            id="title"
            [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('title') }"
          />
          <label for="title"
            >Título * (máximo {{ titleMaxLength }} caracteres)</label
          >
          <small class="error" *ngIf="invalidControl('title')">
            Título é obrigatório e deve respeitar o limite máximo.
          </small>
        </span>

        <span class="p-float-label">
          <input
            type="text"
            pInputText
            formControlName="hashtagCode"
            id="hashtagCode"
            [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('hashtagCode') }"
          />
          <label for="hashtagCode">Hashtag *</label>
          <small class="error" *ngIf="invalidControl('hashtagCode')">
            O campo de hashtag é obrigatório.
          </small>
        </span>

        <div class="input-switch form-row__active">
          <p-inputSwitch formControlName="active" inputId="active" />
          <label for="active">Ativa</label>
        </div>
      </div>

      <span class="p-float-label full-w">
        <textarea
          pInputTextarea
          rows="5"
          formControlName="description"
          id="description"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('description') }"
        ></textarea>
        <label for="description"
          >Descrição * (máximo {{ descriptionMaxLength }} caracteres)</label
        >
        <small class="error" *ngIf="invalidControl('description')">
          Descrição é obrigatória e deve respeitar o limite máximo.
        </small>
      </span>

      <div class="form-row">
        <span class="p-float-label">
          <p-inputNumber
            formControlName="minimumGlampoints"
            inputId="minimumGlampoints"
            mode="decimal"
            [min]="0"
            [step]="0.01"
            [maxFractionDigits]="2"
            [ngClass]="{
              'ng-invalid ng-dirty': invalidControl('minimumGlampoints')
            }"
          />
          <label for="minimumGlampoints">Glampoints mínimo *</label>
          <small class="error" *ngIf="invalidControl('minimumGlampoints')">
            O glampoints mínimo é obrigatório.
          </small>
        </span>
        <span class="p-float-label">
          <p-inputNumber
            formControlName="maximumGlampoints"
            inputId="maximumGlampoints"
            mode="decimal"
            [min]="0"
            [step]="0.01"
            [maxFractionDigits]="2"
            [ngClass]="{
              'ng-invalid ng-dirty': invalidControl('maximumGlampoints')
            }"
          />
          <label for="maximumGlampoints">Glampoints máximo *</label>
          <small class="error" *ngIf="invalidControl('maximumGlampoints')">
            O glampoints máximo é obrigatório.
          </small>
          <small class="error" *ngIf="isGlampointsRangeInvalid()">
            O valor mínimo de glampoints não pode ser maior que o máximo.
          </small>
        </span>
      </div>

      <div class="form-row">
        <span class="p-float-label">
          <p-calendar
            formControlName="startDate"
            inputId="startDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [style]="{ width: '100%' }"
          />
          <label for="startDate">Início</label>
        </span>
        <span class="p-float-label">
          <p-calendar
            formControlName="endDate"
            inputId="endDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [style]="{ width: '100%' }"
          />
          <label for="endDate">Término</label>
          <small class="error" *ngIf="isDateRangeInvalid()">
            A data de início não pode ser maior que a data de término.
          </small>
        </span>
      </div>

      <span class="p-float-label">
        <p-inputNumber
          formControlName="postsToShowInHome"
          inputId="postsToShowInHome"
          [min]="0"
          [useGrouping]="false"
        />
        <label for="postsToShowInHome">Posts na home</label>
      </span>

      <span class="p-float-label full-w">
        <p-chips
          formControlName="topPosts"
          inputId="topPosts"
          [addOnTab]="true"
          [addOnBlur]="true"
          [showClear]="true"
        />
        <label for="topPosts">Top posts (IDs)</label>
        <small>Utilize Enter para adicionar o ID do post</small>
      </span>

      <div class="full-w field-block" formArrayName="steps">
        <label>Passos (exbição no front para o cliente)</label>
        <div
          class="steps-list"
          *ngFor="let stepControl of steps.controls; let i = index"
        >
          <div class="steps-list__header">
            <span>Passo {{ i + 1 }}</span>
            <p-button
              type="button"
              label="Remover"
              severity="danger"
              [outlined]="true"
              (onClick)="removeStep(i)"
            />
          </div>
          <textarea
            pInputTextarea
            rows="3"
            [formControlName]="i"
            [ngClass]="{ 'ng-invalid ng-dirty': isStepInvalid(i) }"
          ></textarea>
        </div>
        <p-button
          type="button"
          label="Adicionar passo"
          [outlined]="true"
          (onClick)="addStep()"
        />
      </div>

      <div class="full-w field-block" formArrayName="rules">
        <label>Regras (que serão avaliadas no vídeo)</label>
        <div
          class="steps-list"
          *ngFor="let ruleControl of rules.controls; let i = index"
        >
          <div class="steps-list__header">
            <span>Regra {{ i + 1 }}</span>
            <p-button
              type="button"
              label="Remover"
              severity="danger"
              [outlined]="true"
              (onClick)="removeRule(i)"
            />
          </div>
          <textarea
            pInputTextarea
            rows="3"
            [formControlName]="i"
            [ngClass]="{ 'ng-invalid ng-dirty': isRuleInvalid(i) }"
          ></textarea>
        </div>
        <p-button
          type="button"
          label="Adicionar regra"
          [outlined]="true"
          (onClick)="addRule()"
        />
      </div>

      <div class="file-upload full-w">
        <span class="p-float-label">
          <input
            type="text"
            pInputText
            formControlName="image"
            id="image"
            readonly
            [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('image') }"
          />
          <label for="image">Imagem * — WEBP | 768x418 | máx. 250kb</label>
          <small class="error" *ngIf="invalidControl('image')">
            A imagem da campanha é obrigatória.
          </small>
        </span>
        <p-fileUpload
          mode="basic"
          chooseLabel="Upload"
          name="campaign-image"
          [auto]="true"
          accept="image/webp"
          [maxFileSize]="250 * 1024"
          (onSelect)="
            handleFileSelect($event, 'image', 768, 418, 250 * 1024, image)
          "
          [showUploadButton]="false"
          [showCancelButton]="false"
          #image
          styleClass="p-button-raised p-button-secondary"
        />
      </div>
      <div class="form-container__img" *ngIf="form.controls.image.value">
        <img [src]="form.controls.image.value" alt="Imagem da campanha" />
      </div>

      <div class="form-row" *ngIf="campaignId">
        <span class="p-float-label">
          <p-calendar
            formControlName="createdAt"
            inputId="createdAt"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showTime]="true"
            [style]="{ width: '100%' }"
          />
          <label for="createdAt">Criada em</label>
        </span>
        <span class="p-float-label">
          <p-calendar
            formControlName="updatedAt"
            inputId="updatedAt"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showTime]="true"
            [style]="{ width: '100%' }"
          />
          <label for="updatedAt">Atualizada em</label>
        </span>
      </div>

      <div class="buttons">
        <p-button
          type="button"
          [outlined]="true"
          severity="secondary"
          label="Cancelar"
          (onClick)="goToMenu()"
        />
        <p-button
          type="submit"
          label="Salvar"
          [disabled]="
            form.invalid || isGlampointsRangeInvalid() || isDateRangeInvalid()
          "
        />
      </div>
    </form>
  </p-tabPanel>

  <p-tabPanel header="Posts" *ngIf="campaignId">
    <div class="posts-toolbar">
      <p-button
        type="button"
        label="Incluir post"
        (onClick)="goToNewPost()"
      />
    </div>
    <app-table
      [service]="campaignHashtagPostsService"
      pageFunctionName="getPostsList"
      [cols]="postsCols"
      [fixedFilters]="postsFixedFilters"
      [dropdownFilters]="postsDropdownFilters"
      sortField="personAccount"
      [sortOrder]="-1"
      [defaultRows]="25"
      [addButton]="false"
      [showTitle]="false"
      modelName="posts"
      emptyMessage="Nenhum post associado a esta campanha"
    />
  </p-tabPanel>
</p-tabView>
